<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <div class="base-color overflow-auto mh-550 shadow">
        <BOverlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <div class="col-sm-12 row">
              <div class="col-sm-6 p-3 mt-2">
                <span>画像を選択してください。</span>
              </div>
            </div>
            <div class="col-sm-12 overflow-auto">
              <div class="card-columns p-3 w-100 production-col-cnt" v-for="(styleImages, index) in suggestionProductData" :key="index">
                <div class="card position-relative border-0 bg-unset card-sqr-gray-products" v-for="(styleImage, i) in styleImages" :key="i">
                  <div class="p-0 h-100" @click="nextPage(styleImage.projectNumber)">
                    <img :src="styleImage.imagePath" class="ar-3-2" :ref="index + '-' + i">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BOverlay>
      </div>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import SuggestionProductModel from '@/models/SuggestionProductModel'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'

export default {
  name: 'CustomerMeetingProductProposal',
  components: { CommonLayout, CustomerMeetingLayout, SuggestionProductModel, SignalingModel },
  data () {
    return {
      overlayShow: false,
      imageRowMaxNum: 2,
      suggestionProductData: [],
      showImageProjectNumbers: [],
      isSendFirstSignalingData: false,
      initImages: [],
      imageSort: [],
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.isSendFirstSignalingData = true

        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // data初期化
          this.reloadDataSet()
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent()
        }
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        console.log('Proposal getSignalingData()')
        console.log('newData ↓')
        console.log(newData)
        if (newData['event'] !== 'api') {
          newData['user'] = 'customer'
          newData['timestampMs'] = Date.now()
          CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
          })
        }
        if (newData['id'] !== 'reDrawMemoImage' && newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            console.log('Set proposalScrollHistoryFlag')
            sessionStorage.setItem('scrollY', window.scrollY)
            sessionStorage.setItem('proposalScrollHistoryFlag', 'True')
            return this.$router.push(synchPass)
          }
        }
        if (!cstore.getters.isOperationPossible) {
          if (newData['event'] === 'click') {
            if (newData['id'] === 'back' || newData['id'] === 'next') {
              if (newData['id'] === 'next') {
                // 画面遷移時に商品一覧のスクロール位置を削除
                sessionStorage.removeItem('proposalScrollHistoryFlag')
                sessionStorage.removeItem('scrollY')
              }
              if (sessionStorage.customerType === this.consts.customerType.guest || sessionStorage.customerType === this.consts.customerType.main) {
                const customerTargetPath = newData['target_path'].replace('florist', 'customer')
                this.$router.push(customerTargetPath)
              } else {
                this.$router.push(newData['target_path'])
              }
            }
            if (newData['id'] === 'reload') {
              this.reloadDataSet()
            }
          }
        }
        if (newData['event'] === 'click') {
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
            }
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
          if (newData['id'] === 'reDrawMemoImage') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'tableRowId': newData['tableRowId']}})
            // 画面遷移時に商品一覧のスクロール位置を削除
            sessionStorage.removeItem('proposalScrollHistoryFlag')
            sessionStorage.removeItem('scrollY')
          }
          if (newData['id'] === 'productDetailFromBookmark') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const targetPath = '/customer/meeting/product_selection/' + this.routeId
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})
            // 画面遷移時に商品一覧のスクロール位置を削除
            sessionStorage.removeItem('proposalScrollHistoryFlag')
            sessionStorage.removeItem('scrollY')
          }
        }

        if (newData['event'] === 'api') {
          newData.data.forEach((nData) => {
            if (this.showImageProjectNumbers.indexOf(nData.images.projectNumber) >= 0) {
              this.suggestionProductData.forEach((productData, key) => {
                productData.forEach((productImage, k) => {
                  if (productImage.projectNumber === nData.images.projectNumber) {
                    productImage.imagePath = nData.images.imagePath
                  }
                })
              })
            } else {
              const imageSortNumber = Number(nData.imageSort)
              const count = this.imageSort.length
              let i = 0
              for (; i < count; i++) {
                if (this.imageSort[i] > imageSortNumber) {
                  break
                }
              }
              this.showImageProjectNumbers.splice(i, 0, nData.images.projectNumber)
              this.initImages.splice(i, 0, nData.images)
              this.imageSort.splice(i, 0, imageSortNumber)
              this.setImageColumn(i, nData.images)
            }
            localStorage.currentProjectType = nData.project_type
            localStorage.suggestionType = nData.suggestion_type
            // 商品一覧の表示履歴があり、スクロール位置が保存されている場合、保存したスクロール位置にスクロールさせる
            if (sessionStorage.getItem('proposalScrollHistoryFlag') === 'True' && sessionStorage.getItem('scrollY') !== null) {
              window.scrollTo(0, sessionStorage.getItem('scrollY'))
            } else {
              window.scrollTo(0, 0)
            }
          })
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    }
  },
  methods: {
    setImageColumn (imageSortNumber, imageObj) {
      if (this.suggestionProductData.length === 0) {
        this.overlayShow = false
        this.suggestionProductData[0] = []
      } else if (this.suggestionProductData[this.suggestionProductData.length - 1].length === this.imageRowMaxNum) {
        this.suggestionProductData[this.suggestionProductData.length] = []
        this.suggestionProductData[this.suggestionProductData.length - 1] = []
      }

      let colPoint = this.suggestionProductData.length - 1
      let rowPoint = this.suggestionProductData[this.suggestionProductData.length - 1].length
      if (imageSortNumber < this.imageRowMaxNum * (this.suggestionProductData.length - 1) + this.suggestionProductData[this.suggestionProductData.length - 1].length) {
        // 途中に値を追加するときは指定した位置にする。
        colPoint = imageSortNumber / this.imageRowMaxNum
        rowPoint = imageSortNumber % this.imageRowMaxNum

        for (let i = colPoint; i < this.suggestionProductData.length - 1; i++) {
          const subImagesArr = this.suggestionProductData[i]
          const subImagesArrAdd = this.suggestionProductData[i + 1]
          subImagesArrAdd.splice(0, 0, subImagesArr[subImagesArr.length - 1])
          subImagesArr.pop()
          this.suggestionProductData[i] = subImagesArr
          this.suggestionProductData[i + 1] = subImagesArrAdd
        }
      }

      const imagesArr = this.suggestionProductData[colPoint]
      imagesArr.splice(rowPoint, 0, imageObj)
      this.suggestionProductData[colPoint] = imagesArr

      if (this.suggestionProductData.length === 0) {
        this.overlayShow = false
        this.suggestionProductData[0] = []
      } else if (this.suggestionProductData[this.suggestionProductData.length - 1].length === this.imageRowMaxNum) {
        this.suggestionProductData[this.suggestionProductData.length] = []
        this.suggestionProductData[this.suggestionProductData.length - 1] = []
      }
    },
    nextPage (projectNumber, isForcedExecution = false) {
      // 操作可能時のみ
      if (cstore.getters.isOperationPossible || isForcedExecution) {
        // 画面遷移時に商品一覧のスクロール位置を保存
        sessionStorage.setItem('scrollY', window.scrollY)
        sessionStorage.setItem('proposalScrollHistoryFlag', 'True')
        const targetPath = '/customer/meeting/product_selection/' + projectNumber
        SignalingModel.sendClickEvent('next', this, {
          'target_path': targetPath.replace('customer', 'florist'),
          'project_number': projectNumber
        })
        this.$router.push({path: targetPath, query: {'projectType': localStorage.currentProjectType, 'suggestionType': localStorage.suggestionType, 'fromProductProposal': true}})
      }
    },
    reloadDataSet () {
      this.showImageProjectNumbers = []
      this.suggestionProductData = []
      this.initImages = []
      this.imageSort = []
      // 画面再描画時に商品一覧のスクロール位置を削除
      sessionStorage.removeItem('proposalScrollHistoryFlag')
      sessionStorage.removeItem('scrollY')
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    }
  }
}
</script>
